/**
 * @generated SignedSource<<2ce78a758fe40736a11cd4ece023d11c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExportMenuItem_note$data = {
  readonly stream: {
    readonly " $fragmentSpreads": FragmentRefs<"ExportToDocs_stream">;
  };
  readonly " $fragmentType": "ExportMenuItem_note";
};
export type ExportMenuItem_note$key = {
  readonly " $data"?: ExportMenuItem_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExportMenuItem_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExportMenuItem_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ExportToDocs_stream"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "e0c10e0b67302d68becc80b9b05a2ba2";

export default node;
